"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defValidate = void 0;
var tslib_1 = require("tslib");
// (C) 2021 GoodData Corporation
var groupBy_1 = tslib_1.__importDefault(require("lodash/groupBy"));
var toPairs_1 = tslib_1.__importDefault(require("lodash/toPairs"));
var ts_invariant_1 = tslib_1.__importDefault(require("ts-invariant"));
var attribute_1 = require("../attribute");
var measure_1 = require("../measure");
/**
 * Validates the {@link IExecutionDefinition} instance and throws if it is invalid.
 * @param definition - the definition to validate
 * @internal
 */
function defValidate(definition) {
    var itemsWithLocalId = tslib_1.__spreadArrays(definition.attributes, definition.measures);
    var groups = groupBy_1.default(itemsWithLocalId, function (item) {
        return attribute_1.isAttribute(item) ? attribute_1.attributeLocalId(item) : measure_1.measureLocalId(item);
    });
    toPairs_1.default(groups).forEach(function (_a) {
        var localId = _a[0], items = _a[1];
        ts_invariant_1.default(items.length === 1, "There are " + items.length + " items with the same localId '" + localId + "'. Please make sure the attributes and measures in the execution definition have unique localIds.");
    });
}
exports.defValidate = defValidate;
//# sourceMappingURL=validation.js.map